import CommonError from '../Common/CommonError'

const Error401Container = () => {
  return (
    <CommonError error="401" color="warning" src="sad"/>
  )
}

export default Error401Container